<template>
  <div class="assignment-number mr-4">
    <router-link :to="assignmentsPage" class="mr-4">
      <a class="back-to position-absolute">
        <mdicon name="ChevronLeft" />
      </a>
    </router-link>
    <span class="ml-1">Assignment #{{ assignment.reference }}</span>
  </div>
</template>

<script lang="ts">
import type { Assignment } from '@/types/Models/Assignment'
import { defineComponent, computed, type ComputedRef } from 'vue'
import { useAccountStore } from '@/store/account'
import { useAssignmentSummaryStore } from '@/store/assignmentSummary'
import { CUSTOMER_ASSIGNMENTS_LIST, STAFF_ASSIGNMENTS_LIST } from '@/types/router'

export default defineComponent({
  name: 'Reference',
  setup() {
    const assignmentSummaryStore = useAssignmentSummaryStore()
    const accountStore = useAccountStore()

    const assignment: ComputedRef<Assignment> = computed(() => assignmentSummaryStore.assignment as Assignment)
    const isStaff: ComputedRef<boolean> = computed(() => accountStore.isStaff)

    return {
      assignment,
      assignmentsPage: computed(() => ({
        name: isStaff.value ? STAFF_ASSIGNMENTS_LIST : CUSTOMER_ASSIGNMENTS_LIST,
      })),
    }
  },
})
</script>
